// script.js

document.addEventListener('DOMContentLoaded', () => {
    // Get references to DOM elements
    const startButton = document.getElementById('start-button');
    const homePage = document.getElementById('home-page');
    const planGeneration = document.getElementById('plan-generation');
    const planForm = document.getElementById('plan-form');
    const durationSelect = document.getElementById('duration');
    const customDurationInput = document.getElementById('custom-duration');
    const specificBooksCheckbox = document.querySelector('input[value="specific-books"]');
    const specificBooksSelection = document.getElementById('specific-books-selection');
    const thematicPlansCheckbox = document.querySelector('input[value="thematic-plans"]');
    const thematicPlansSelection = document.getElementById('thematic-plans-selection');
    const addCustomThemeButton = document.getElementById('add-custom-theme');
    const themesSelect = document.getElementById('themes');
    const customThemeInput = document.getElementById('custom-theme');
    const booksSelect = document.getElementById('books');
    const planDisplay = document.getElementById('plan-display');
    const planDetails = document.getElementById('plan-details');
    const progressBar = document.getElementById('progress-bar');
    const progressPercentage = document.getElementById('progress-percentage');
    const downloadPlanButton = document.getElementById('download-plan');
    const exportIcsButton = document.getElementById('export-ics');
    const resetPlanButton = document.getElementById('reset-plan');
    const readingDaysContainer = document.getElementById('reading-days-container');

    // Variables to store plan data and progress
    let readingPlan = [];
    let completedDays = new Set();

    // Event listener for Start button
    startButton.addEventListener('click', () => {
        homePage.style.display = 'none';
        planGeneration.style.display = 'block';
    });

    // Event listener for Duration select
    durationSelect.addEventListener('change', () => {
        if (durationSelect.value === 'custom') {
            customDurationInput.style.display = 'block';
        } else {
            customDurationInput.style.display = 'none';
        }
    });

    // Event listener for Specific Books checkbox
    specificBooksCheckbox.addEventListener('change', (e) => {
        specificBooksSelection.style.display = e.target.checked ? 'block' : 'none';
    });

    // Event listener for Thematic Plans checkbox
    thematicPlansCheckbox.addEventListener('change', (e) => {
        thematicPlansSelection.style.display = e.target.checked ? 'block' : 'none';
    });

    // Event listener for Add Custom Theme button
    addCustomThemeButton.addEventListener('click', () => {
        const customTheme = customThemeInput.value.trim();
        if (customTheme) {
            const existingOption = Array.from(themesSelect.options).find(option => option.value.toLowerCase() === customTheme.toLowerCase());
            if (!existingOption) {
                const option = document.createElement('option');
                option.value = customTheme;
                option.textContent = customTheme;
                option.selected = true;
                themesSelect.appendChild(option);
                customThemeInput.value = '';
            } else {
                alert('This theme already exists in the list.');
            }
        } else {
            alert('Please enter a theme.');
        }
    });

    // Populate the Books select element
    const booksOfBible = [
        'Genesis', 'Exodus', 'Leviticus', 'Numbers', 'Deuteronomy',
        'Joshua', 'Judges', 'Ruth', '1 Samuel', '2 Samuel',
        '1 Kings', '2 Kings', '1 Chronicles', '2 Chronicles', 'Ezra',
        'Nehemiah', 'Esther', 'Job', 'Psalms', 'Proverbs',
        'Ecclesiastes', 'Song of Solomon', 'Isaiah', 'Jeremiah', 'Lamentations',
        'Ezekiel', 'Daniel', 'Hosea', 'Joel', 'Amos',
        'Obadiah', 'Jonah', 'Micah', 'Nahum', 'Habakkuk',
        'Zephaniah', 'Haggai', 'Zechariah', 'Malachi',
        'Matthew', 'Mark', 'Luke', 'John', 'Acts',
        'Romans', '1 Corinthians', '2 Corinthians', 'Galatians', 'Ephesians',
        'Philippians', 'Colossians', '1 Thessalonians', '2 Thessalonians', '1 Timothy',
        '2 Timothy', 'Titus', 'Philemon', 'Hebrews', 'James',
        '1 Peter', '2 Peter', '1 John', '2 John', '3 John',
        'Jude', 'Revelation'
    ];

    booksOfBible.forEach(book => {
        const option = document.createElement('option');
        option.value = book;
        option.textContent = book;
        booksSelect.appendChild(option);
    });

    // Populate the Preferred Reading Days section with checkboxes
    const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    daysOfWeek.forEach(day => {
        const checkbox = document.createElement('input');
        checkbox.type = 'checkbox';
        checkbox.value = day.toLowerCase();
        checkbox.id = `reading-day-${day.toLowerCase()}`;
        const label = document.createElement('label');
        label.htmlFor = checkbox.id;
        label.textContent = day;
        readingDaysContainer.appendChild(checkbox);
        readingDaysContainer.appendChild(label);
    });

    // Event listener for form submission
    planForm.addEventListener('submit', (e) => {
        e.preventDefault();
        // Collect user inputs
        const duration = durationSelect.value === 'custom' ? parseInt(customDurationInput.value) : parseInt(durationSelect.value);
        const sections = Array.from(document.querySelectorAll('input[name="sections"]:checked')).map(input => input.value);
        const selectedBooks = Array.from(booksSelect.selectedOptions).map(option => option.value);
        const themes = Array.from(themesSelect.selectedOptions).map(option => option.value);
        const startDate = new Date(document.getElementById('start-date').value);
        const readingDays = Array.from(readingDaysContainer.querySelectorAll('input[type="checkbox"]:checked')).map(input => input.value);
        const readingTime = document.getElementById('reading-time').value;
        const readingMode = document.querySelector('input[name="reading-mode"]:checked').value;

        // Validate inputs
        if (isNaN(duration) || duration <= 0) {
            alert('Please enter a valid duration.');
            return;
        }
        if (sections.length === 0) {
            alert('Please select at least one Bible section.');
            return;
        }
        if (isNaN(startDate.getTime())) {
            alert('Please select a valid start date.');
            return;
        }
        if (readingDays.length === 0) {
            alert('Please select at least one preferred reading day.');
            return;
        }

        // Generate the reading plan
        readingPlan = generateReadingPlan(duration, sections, selectedBooks, themes, startDate, readingDays, readingTime, readingMode);

        // Display the plan
        displayReadingPlan(readingPlan);

        // Save the plan and progress to localStorage
        savePlanToLocalStorage();

        // Switch to the plan display section
        planGeneration.style.display = 'none';
        planDisplay.style.display = 'block';
    });

    // Load plan on page load
    loadPlanFromLocalStorage();

    // Event listener for Download Plan button
    downloadPlanButton.addEventListener('click', () => {
        downloadPlanAsText();
    });

    // Event listener for Export to Calendar button
    exportIcsButton.addEventListener('click', () => {
        exportPlanToICS();
    });

    // Event listener for Reset Plan button
    resetPlanButton.addEventListener('click', () => {
        if (confirm('Are you sure you want to reset your plan? This action cannot be undone.')) {
            localStorage.removeItem('readingPlan');
            readingPlan = [];
            completedDays.clear();
            progressBar.value = 0;
            progressPercentage.textContent = '0% Complete';
            planDetails.innerHTML = '';
            planDisplay.style.display = 'none';
            planGeneration.style.display = 'block';
        }
    });

    // Function to generate the reading plan
    function generateReadingPlan(duration, sections, selectedBooks, themes, startDate, readingDays, readingTime, readingMode) {
        let plan = [];
        // Fetch the chapters based on the user's selections
        let chapters = getChapters(sections, selectedBooks, themes, readingMode);
        const totalDays = duration;
        const chaptersPerDay = Math.ceil(chapters.length / totalDays);
        let scheduleDates = getScheduleDates(startDate, totalDays, readingDays);
        let chapterIndex = 0;
        for (let date of scheduleDates) {
            if (chapterIndex >= chapters.length) break;
            let dailyChapters = chapters.slice(chapterIndex, chapterIndex + chaptersPerDay);
            plan.push({
                date: date,
                chapters: dailyChapters,
                completed: false
            });
            chapterIndex += chaptersPerDay;
        }
        return plan;
    }

    // Function to get chapters based on selections
    function getChapters(sections, selectedBooks, themes, readingMode) {
        let chapters = [];
        const bookChapters = booksOfBible.reduce((acc, book) => {
            acc[book] = Array.from({ length: 10 }, (_, i) => `Chapter ${i + 1}`);
            return acc;
        }, {});
        const themeToBooksMap = {
            'hope': ['Psalms', 'Isaiah'],
            'faith': ['Romans', 'Hebrews'],
            'love': ['1 Corinthians', '1 John'],
            'forgiveness': ['Ephesians', 'Colossians'],
            'wisdom': ['Proverbs', 'Ecclesiastes'],
            'strength': ['Joshua', 'Philippians'],
            'peace': ['John', 'Philippians'],
            'healing': ['Luke', 'James'],
            'gratitude': ['Psalms', '1 Thessalonians'],
            'prayer': ['Psalms', 'Matthew'],
            'default': ['Psalms', 'Proverbs', 'John']
        };
        if (sections.includes('old-testament')) {
            booksOfBible.slice(0, 39).forEach(book => {
                chapters = chapters.concat(bookChapters[book].map(chapter => `${book} ${chapter}`));
            });
        }
        if (sections.includes('new-testament')) {
            booksOfBible.slice(39).forEach(book => {
                chapters = chapters.concat(bookChapters[book].map(chapter => `${book} ${chapter}`));
            });
        }
        if (sections.includes('specific-books')) {
            selectedBooks.forEach(book => {
                chapters = chapters.concat(bookChapters[book].map(chapter => `${book} ${chapter}`));
            });
        }
        if (sections.includes('thematic-plans')) {
            themes.forEach(theme => {
                const lowerCaseTheme = theme.toLowerCase();
                let themeBooks = themeToBooksMap[lowerCaseTheme];
                if (!themeBooks) {
                    themeBooks = themeToBooksMap['default'];
                }
                themeBooks.forEach(book => {
                    chapters = chapters.concat(bookChapters[book].map(chapter => `${book} ${chapter}`));
                });
            });
        }
        chapters = [...new Set(chapters)];
        if (readingMode === 'thematic') {
            chapters = shuffleArray(chapters);
        }
        return chapters;
    }

    // Utility function to shuffle an array
    function shuffleArray(array) {
        let currentIndex = array.length, temporaryValue, randomIndex;
        while (0 !== currentIndex) {
            randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex -= 1;
            temporaryValue = array[currentIndex];
            array[currentIndex] = array[randomIndex];
            array[randomIndex] = temporaryValue;
        }
        return array;
    }

    // Function to generate schedule dates based on preferred reading days
    function getScheduleDates(startDate, totalDays, readingDays) {
        let dates = [];
        let currentDate = new Date(startDate);
        while (dates.length < totalDays) {
            const dayName = currentDate.toLocaleDateString('en-US', { weekday: 'long' }).toLowerCase();
            if (readingDays.includes(dayName)) {
                dates.push(new Date(currentDate));
            }
            currentDate.setDate(currentDate.getDate() + 1);
        }
        return dates;
    }

    // Function to display the reading plan
    function displayReadingPlan(plan) {
        planDetails.innerHTML = '';
        const table = document.createElement('table');
        const thead = document.createElement('thead');
        const headerRow = document.createElement('tr');
        ['Date', 'Reading', 'Completed'].forEach(text => {
            const th = document.createElement('th');
            th.textContent = text;
            headerRow.appendChild(th);
        });
        thead.appendChild(headerRow);
        table.appendChild(thead);
        const tbody = document.createElement('tbody');
        plan.forEach((entry, index) => {
            const row = document.createElement('tr');
            const dateCell = document.createElement('td');
            dateCell.textContent = entry.date.toLocaleDateString();
            row.appendChild(dateCell);
            const readingCell = document.createElement('td');
            readingCell.textContent = entry.chapters.join(', ');
            row.appendChild(readingCell);
            const completedCell = document.createElement('td');
            const checkbox = document.createElement('input');
            checkbox.type = 'checkbox';
            checkbox.checked = entry.completed;
            checkbox.addEventListener('change', () => {
                entry.completed = checkbox.checked;
                updateProgress();
                savePlanToLocalStorage();
            });
            completedCell.appendChild(checkbox);
            row.appendChild(completedCell);
            tbody.appendChild(row);
        });
        table.appendChild(tbody);
        planDetails.appendChild(table);
        updateProgress();
    }

    // Function to update the progress bar and percentage
    function updateProgress() {
        const totalDays = readingPlan.length;
        const completedCount = readingPlan.filter(entry => entry.completed).length;
        const progress = (completedCount / totalDays) * 100;
        progressBar.value = progress;
        progressPercentage.textContent = `${Math.round(progress)}% Complete`;
    }

    // Function to save plan and progress to localStorage
    function savePlanToLocalStorage() {
        localStorage.setItem('readingPlan', JSON.stringify(readingPlan));
    }

    // Function to load plan from localStorage
    function loadPlanFromLocalStorage() {
        const storedPlan = localStorage.getItem('readingPlan');
        if (storedPlan) {
            readingPlan = JSON.parse(storedPlan);
            readingPlan.forEach(entry => {
                entry.date = new Date(entry.date);
            });
            displayReadingPlan(readingPlan);
            planGeneration.style.display = 'none';
            planDisplay.style.display = 'block';
        }
    }

    // Function to download plan as text file
    function downloadPlanAsText() {
        let content = 'Date\tReading\n';
        readingPlan.forEach(entry => {
            const dateStr = entry.date.toLocaleDateString();
            const readings = entry.chapters.join(', ');
            content += `${dateStr}\t${readings}\n`;
        });
        const blob = new Blob([content], { type: 'text/plain;charset=utf-8' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'Bible_Reading_Plan.txt';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }

    // Function to export plan as .ics file
    function exportPlanToICS() {
        let icsContent = 'BEGIN:VCALENDAR\nVERSION:2.0\nPRODID:-//Bible Reading Plan//EN\n';
        readingPlan.forEach(entry => {
            const date = entry.date;
            const dateStr = date.toISOString().replace(/[-:]/g, '').split('.')[0];
            const endDate = new Date(date);
            endDate.setHours(endDate.getHours() + 1);
            const endDateStr = endDate.toISOString().replace(/[-:]/g, '').split('.')[0];
            icsContent += 'BEGIN:VEVENT\n';
            icsContent += `UID:${dateStr}@biblereadingplan\n`;
            icsContent += `DTSTAMP:${dateStr}Z\n`;
            icsContent += `DTSTART:${dateStr}Z\n`;
            icsContent += `DTEND:${endDateStr}Z\n`;
            icsContent += `SUMMARY:Bible Reading: ${entry.chapters.join(', ')}\n`;
            icsContent += 'END:VEVENT\n';
        });
        icsContent += 'END:VCALENDAR';
        const blob = new Blob([icsContent], { type: 'text/calendar;charset=utf-8' });
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'Bible_Reading_Plan.ics';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }
});
